import { applyFilters } from '@wordpress/hooks'
import CardEnum from '../../enumerators/card.enum'

export default class ShowTraceComponent {
    constructor() {
        ShowTraceComponent.show()
    }

    static show() {
        let linkColor = getComputedStyle(document.documentElement).getPropertyValue(
            '--iris--gpx--color',
        )
        if (!linkColor) {
            linkColor = getComputedStyle(document.documentElement).getPropertyValue(
                '--iris--link--color',
            )
        }
        const traceColor = applyFilters('iris.etourism.list_color_kml_offer', linkColor)

        $(CardEnum.CARD_SHOW_TRACE).on('click', function () {
            const gpx = $(this).attr('data-gpx')

            if ($(this).find(CardEnum.CARD_SHOW_TRACE_TOGGLE).hasClass('active')) {
                $(this).find(CardEnum.CARD_SHOW_TRACE_TOGGLE).removeClass('active')
                window.IrisMap.maps[0].resetKmlGpx('gpx')
                $(document).trigger('wp-etourisme-v3/map/fitbounds')
            } else {
                $(CardEnum.CARD_SHOW_TRACE)
                    .find(CardEnum.CARD_SHOW_TRACE_TOGGLE)
                    .removeClass('active')
                window.IrisMap.maps[0].resetKmlGpx('gpx')
                $(this).find(CardEnum.CARD_SHOW_TRACE_TOGGLE).addClass('active')
                window.IrisMap.maps[0].addKmlGpx(gpx, { id: 'gpx', color: traceColor, width: 3 })
            }
        })
    }
}
